<template>
  <el-dropdown trigger="click" placement="bottom-end" @command="onDropDownClick" @visible-change="dropDownActive = false" :tabindex="-1">
    <i class="el-dropdown-link ellipsis" />
    <el-dropdown-menu>
      <li style="display: flex;">
        <div class="el-dropdown-menu__item" :class="{active: dropDownActive}" style="height: 36px;" @click="toggle">TSV Upload<i class="el-icon-arrow-right" style="margin-left: 8px;"></i></div>
        <div class="dropdown_inner" v-show="dropDownActive">
          <el-dropdown-item command="tsvUpload">Upload</el-dropdown-item>
          <el-dropdown-item command="templateDownload">Template Download</el-dropdown-item>
        </div>
      </li>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'TwDropDownTsv',
  data() {
    return {
      dropDownActive: false,
    };
  },
  methods: {
    resize() {
      var event;
      if (typeof (Event) === 'function') {
          event = new Event('resize');
      } else { /*IE*/
          event = document.createEvent('Event');
          event.initEvent('resize', true, true);
      }
      window.dispatchEvent(event);
    },
    toggle() {
      this.dropDownActive = !this.dropDownActive;
      requestAnimationFrame(() => {
        this.resize();
        this.resize();
      });
    },
    // eslint-disable-next-line no-unused-vars
    onDropDownClick(command) {
      // if (command === 'tsvUpload') {
        
      // } else if (command === 'templateDownload') {

      // }
    }
  }
};
</script>

<style scoped>
.el-dropdown-menu.el-popper {
  z-index: 2000!important;
}
.el-dropdown-menu__item.active {
  background-color: #eef3f9;
  color: #749dd1;
}
</style>